
import {  ProductComponent } from "../../types";
import {v4 as uuid} from 'uuid';

export const create = (createdBy : string, fields? : Partial<ProductComponent>) : ProductComponent => {     
    return  {
        createdBy: createdBy,
        dateCreated: new Date().getTime(),
        id: uuid(),
        code: "",
        categories: [],
        description: "",
        price: 0,
        oldprice: 0,
        margin: 0,
        discount: 0,
        priceType: "SIMPLE",
        priceExpression: null,
        supplierId: null,
        image: "",
        components: [],
        ...fields
}};